import request from '../utils/RequestUtil';

function listAccounts() {
  return request({
    url: '/cuenta',
    method: 'POST'
  });
}

function validateCV(){
  return request({
    url: '/cuentaVista/validar',
    method: 'POST'
  });
}

// eslint-disable-next-line import/prefer-default-export
export { listAccounts, validateCV };
